import { Injectable, computed, signal } from '@angular/core';
import { Product, WishlistItem } from '../models/product.model';

const STORAGE_KEY = 'hnh_jewellery_wishlist';

@Injectable({ providedIn: 'root' })
export class WishlistService {
  private readonly itemsSignal = signal<WishlistItem[]>(this.loadFromStorage());

  readonly items = this.itemsSignal.asReadonly();
  readonly count = computed(() => this.itemsSignal().length);

  has(productId: number): boolean {
    return this.itemsSignal().some((item) => item.id === productId);
  }

  toggle(product: Product): void {
    if (this.has(product.id)) {
      this.remove(product.id);
      return;
    }

    const item: WishlistItem = {
      id: product.id,
      name: product.name,
      slug: product.slug,
      price: product.price,
      discount: product.discount,
      thumbnail_url: product.thumbnail_url || product.images[0] || '',
    };

    this.itemsSignal.set([...this.itemsSignal(), item]);
    this.persist();
  }

  remove(productId: number): void {
    this.itemsSignal.set(
      this.itemsSignal().filter((item) => item.id !== productId)
    );
    this.persist();
  }

  private persist(): void {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(this.itemsSignal())
    );
  }

  private loadFromStorage(): WishlistItem[] {
    if (typeof window === 'undefined') return [];
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? (JSON.parse(raw) as WishlistItem[]) : [];
    } catch {
      return [];
    }
  }
}
